import { render, staticRenderFns } from "./personnelManagementSystem.vue?vue&type=template&id=78474874&scoped=true&"
import script from "./personnelManagementSystem.vue?vue&type=script&lang=js&"
export * from "./personnelManagementSystem.vue?vue&type=script&lang=js&"
import style0 from "./personnelManagementSystem.vue?vue&type=style&index=0&id=78474874&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78474874",
  null
  
)

export default component.exports